module.exports = __webpack_public_path__ + "img/lamden-flows.d0135914.png";